import { UserTypes } from "../models/userTypes";

export const Utils = {
    isCustomer: function (user) {
        return user?.type === UserTypes.CUSTOMER;
    },
    isChef: function (user) {
        return user?.type === UserTypes.CHEF;
    },
    getDeliveryMethodText: function (kitchenData, options = {}) {
        const { concise = false } = options;
        const providesDelivery = Boolean(kitchenData?.providesDelivery);
        const acceptsPickup = Boolean(kitchenData?.acceptsPickup);

        if (providesDelivery && acceptsPickup) {
            return 'Delivery & Pickup';
        }

        if (providesDelivery) {
            return concise ? 'Delivery' : 'Delivery only';
        }

        if (acceptsPickup) {
            return concise ? 'Pickup' : 'Pickup only';
        }

        return 'No delivery or pickup';
    },
    isCustomerReady: function (user) {
        return Boolean(
            user?.firstName &&
            user?.lastName &&
            user?.email &&
            user?.phoneNumber &&
            user?.profilePic &&
            user?.customer?.complianceAcknowledgment
        );
    },  
    validateEmailFormat: function (email) {
            if (!email || !email.trim()) {
                return false;
            }

            return /^[^\s@]+@[^\s@]+\.[A-Za-z]{2,}$/.test(email.trim());
    },
    formatPhoneNumber: function (value) {
            if (!value) return '';

            const cleaned = value.replace(/\D/g, '');
            const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
            if (match) {
                return `(${match[1]}) ${match[2]}-${match[3]}`;
            }

            return value;
    },
    formatISODateToStandard: function (dateValue) {
            if (!dateValue || dateValue === 'null' || String(dateValue).trim() === '') {
                return '';
            }

            const rawValue = String(dateValue).trim();
            const match = rawValue.match(/^(\d{4})-(\d{2})-(\d{2})[T\s](\d{2}):(\d{2})(?::(\d{2}))?(?:\.(\d{1,3}))?(?:Z|[+-]\d{2}:?\d{2})?$/i);
            if (!match) {
                const parsedDate = new Date(rawValue);
                if (Number.isNaN(parsedDate.getTime())) {
                    return '';
                }

                const year = parsedDate.getFullYear();
                if (year <= 1) {
                    return '';
                }

                const formattedDate = parsedDate.toLocaleDateString('en-US', {
                    month: '2-digit',
                    day: '2-digit',
                    year: 'numeric'
                });

                const formattedTime = parsedDate.toLocaleTimeString('en-US', {
                    hour: '2-digit',
                    minute: '2-digit',
                    hour12: true
                }).toLowerCase();

                return `${formattedDate} ${formattedTime}`;
            }

            const [, year, month, day, hour, minute, second = '00', milliseconds = '0'] = match;
            const parsedDate = new Date(
                Number(year),
                Number(month) - 1,
                Number(day),
                Number(hour),
                Number(minute),
                Number(second),
                Number((milliseconds + '000').slice(0, 3))
            );

            if (Number.isNaN(parsedDate.getTime())) {
                return '';
            }

            const formattedDate = parsedDate.toLocaleDateString('en-US', {
                month: '2-digit',
                day: '2-digit',
                year: 'numeric'
            });

            const formattedTime = parsedDate.toLocaleTimeString('en-US', {
                hour: '2-digit',
                minute: '2-digit',
                hour12: true
            }).toLowerCase();

            return `${formattedDate} ${formattedTime}`;
    }
};

export const MathUtils = {
    roundToTwoDecimals: (value) => {
      return Math.round(value * 100) / 100;
    }
};